<div class="testimonials-wrap">

  <h3 class="title">{{ 'testimonials.title' | translate }}</h3>
  <div class="testimonial-container" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">

    <!-- Left navigation control -->
    <div class="control left" (click)="prev()">
      <div class="thumb">
        <img [src]="testimonials[(current - 1 + testimonials.length) % testimonials.length].img" alt="prev" />
      </div>
      <button class="btn prev">
        <span class="me-4">&lt;</span>
        <span> {{ 'Prev' | translate }}</span>
      </button>
    </div>

    <!-- Main Card -->
    <div class="main-card">
      <div class="img-wrap">
        <img [src]="testimonials[current].img" alt="{{testimonials[current].name}}" />
      </div>
      <div class="content">
        <p class="quote">{{ testimonials[current].text | translate }}</p>
        <h5 class="name">{{ testimonials[current].name | translate }}</h5>
        <p class="role">{{ testimonials[current].role | translate }}</p>
      </div>
    </div>

    <!-- Right navigation control -->
    <div class="control right" (click)="next()">
      <div class="thumb">
        <img [src]="testimonials[(current + 1) % testimonials.length].img" alt="next" />
      </div>
      <button class="btn next">
        <span>{{ 'Next' | translate }}</span>
        <span class="ms-4">&gt;</span>
      </button>
    </div>

    <div class="dots-container">
      <span *ngFor="let testimonial of testimonials; let i = index" class="dot" [class.active]="i === current"
        (click)="goToSlide(i)">
      </span>
    </div>
  </div>
</div>